import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class ProductionParametersTableHeader extends Component
{
  static Layout = [
      { column: "Parameter", name: "Parameter" ,width: 5},
      { column: "value", name: "Value",width: 4 },
      { column: "siteKey",  name: "Site Key",width: 2 },
      { column: "empty", width: 1 }
  ];

  render() {
      return (
          <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={ProductionParametersTableHeader.Layout}/>
      )
  }
}